import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
export interface pageObject {
  pageNum: number,
  selected: boolean,
}
@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule,  NgxPaginationModule ],
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {
  @Input() config: { id: string, currentPage: number };
  @Input() total: number;
  @Input() custompageInfo: boolean = true;
  @Input() limit: number;
  @Input() pageObject: { pageNum: number, selected: boolean }[];
  @Output() pageChange = new EventEmitter<number>();

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.config || changes.total || changes.limit) {
      this.generatePageObject();
    }
  }

  get totalPages(): number {
    return Math.ceil(this.total / this.limit);
  }

  generatePageObject() {
    this.pageObject = Array.from({ length: this.totalPages }, (_, i) => ({
      pageNum: i + 1,
      selected: i + 1 === this.config.currentPage
    }));
  }

  getSearchOrCollectionData(page: number) {
    if (page > 0 && page <= this.totalPages) {
      this.config.currentPage = page;
      this.pageChange.emit(this.config.currentPage);
      this.generatePageObject();
    }
  }
}
